/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_A8Inputs */

const en_pc_faq_a8 = /** @type {(inputs: Pc_Faq_A8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Menu, then Edit, then Preferences (⌘, on a Mac or Ctrl+, elsewhere). Auto follows your system language, and you can pick any translated language from the list.`)
};

const zh_pc_faq_a8 = /** @type {(inputs: Pc_Faq_A8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`依次打开「Menu」、「Edit」、「Preferences」（Mac 上按 ⌘,，其他系统按 Ctrl+,）。「Auto」会跟随系统语言，也可以从列表中选择任意已翻译的语言。`)
};

/**
* | output |
* | --- |
* | "Open Menu, then Edit, then Preferences (⌘, on a Mac or Ctrl+, elsewhere). Auto follows your system language, and you can pick any translated language from th..." |
*
* @param {Pc_Faq_A8Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_a8 = /** @type {((inputs?: Pc_Faq_A8Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_A8Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_a8(inputs)
	return zh_pc_faq_a8(inputs)
});
export { pc_faq_a8 as "pc.faq.a8" }